module.exports = __webpack_public_path__ + "static/media/Twitter_Logo_Blue.a7a925c7.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/Twitter_Logo_Blue.svg
 ** module id = 209
 ** module chunks = 0
 **/